'use client';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import styles from '../styles.module.css';
import { LayoutContext } from '@/context/LayoutContext';
import MainIcons from '@/icons/main';

interface SendCodeTimerProps {
  onSend: () => Promise<void> | void;
  duration?: number;
}

const SendCodeTimer: React.FC<SendCodeTimerProps> = ({ onSend, duration = 60 }) => {
  const tlogin = useTranslations('common');
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  // const { dir } = useContext(LayoutContext);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isRunning && timeLeft > 0) {
      timer = setTimeout(() => setTimeLeft((t) => t - 1), 1000);
    } else if (timeLeft === 0) {
      setIsRunning(false);
    }
    return () => clearTimeout(timer);
  }, [isRunning, timeLeft]);

  // const handleSendCode = async () => {
  //   if (isRunning) return;
  //   try {
  //     await onSend();
  //     setTimeLeft(duration);
  //     setIsRunning(true);
  //   } catch (error) {
  //     console.error('Send code failed:', error);
  //   }
  // };
  const handleSendCode = async () => {
    console.log('before await');
    if (isRunning) return;

    // try {
    //   await onSend();
    //   console.log('after await'); // Should NOT print on a 401
    //   setTimeLeft(duration);
    //   setIsRunning(true);
    // } catch (error) {
    //   console.log('error-sendcode', error);

    //   // Reset timer
    //   setIsRunning(false);
    //   setTimeLeft(0);
    // }
    try {
      const response: any = await onSend();

      if (response.code === 'INTERNAL_ERROR') {
        setIsRunning(false);
        setTimeLeft(0);
        return;
      }

      setTimeLeft(duration);
      setIsRunning(true);
    } catch (error) {
      setIsRunning(false);
      setTimeLeft(0);
    }
  };

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };
  return (
    <div className={`${styles.wrapperTimer}`}>
      <MainIcons.RefreshIcon fill="var(--accent-light)" width="12px" height="12px" />
      <span
        className={`${styles.resendButton} ${isRunning ? 'disabledButton' : ''}`}
        onClick={handleSendCode}
      >
        {tlogin(`resendCode`)}
      </span>
      {isRunning && <span className={`${styles.timer}`}>{formatTime(timeLeft)}</span>}
    </div>
  );
};

export default SendCodeTimer;
